/* eslint-disable no-unused-vars */
import http from '../../../Utils/http';

const InviteAdertsier = {
  name: 'inviteAdertsier',
  state: {
    data: {},
    addvertiser: {},
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: ['name', 'type', 'owner'],
    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },
    getReceiveAdvertiserData(state, payload) {
      return {
        ...state,
        addvertiser: payload,
        loading: false,
        error: '',
      };
    },
    getReceived(state, payload) {
      return {
        ...state,
        data: Object.assign({}, state.data, payload),
        loading: false,
        error: '',
      };
      
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
  },
  effects: (dispatch) => ({
    addData(data) {
      dispatch.inviteAdertsier.getReceived(data);
    },

    async sendData(data) {
      try {
        dispatch.inviteAdertsier.getRequested();
        const response = await http.post(`savvy/organization/withOwner`, data);
        this.getReceiveAdvertiserData(response.data.data);
        return { success: true, data: response.data.data };
      } catch (err) {
        const message = (err && err.response && (err.response.data?.message || err.response.data?.error)) || err.message || 'Failed to send invitation';
        dispatch.inviteAdertsier.getRequestFailed(message);
        return { success: false, message };
      }
    },
  }),
};

export default InviteAdertsier;
